import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MultifocalFields = styled.div`
  display: flex;
  border-top: 1px solid #F3F4F5;
  padding-top: 5px;
`;